<template>
  <div class="list">
    <notifications />
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.ssoTenants')"
              :anzahl="filteredTenants.length"
            />
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row mt-2 d-flex justify-content-between">
                  <div class="ml-4 mr-2">
                    <router-link
                      class="btn btn-success mr-2"
                      :to="{ name: 'sso-tenant', params: { id: null } }"
                    >
                      <font-awesome-icon icon="fa-solid fa-plus" class="mr-2" />
                      <span>{{ $t('global.new') }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <b-table
                  ref="selectableTable"
                  small
                  tbody-tr-class="item"
                  :items="filteredTenants"
                  :fields="fields"
                  :busy="loading"
                  sort-icon-left
                  fixed
                  @row-dblclicked="openTenant"
                  thead-tr-class="pointer"
                >
                  <template slot="top-row" slot-scope="{ fields }">
                    <td v-for="field in fields" :key="field.key" class="no-pointer">
                      <b-input
                        v-if="field.searchable !== false"
                        size="sm"
                        v-model="filters[field.key]"
                        :placeholder="field.label"
                        autocomplete="off"
                      />
                    </td>
                  </template>

                  <template #cell(activ)="{ value }">
                    <span :class="value ? 'text-success' : 'text-muted'">
                      {{ value ? $t('global.active') : $t('global.inactive') }}
                    </span>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-primary my-2">
                      <b-spinner class="align-middle" />
                    </div>
                  </template>

                  <template #empty>
                    <div class="text-center text-primary my-2">
                      <strong>{{ $t('global.nodataavailable') }}</strong>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api/AppApi";
import page from "@/mixins/Page";
import Navbar from "@/components/Navbar";
import HeadMenu from "@/components/HeadMenu";
import store from "@/store";

export default {
  name: "SsoTenantListe",
  components: { Navbar, HeadMenu },
  mixins: [page],
  store,
  data() {
    return {
      tenants: [],
      loading: false,
      docsName: "SsoTenantListe",
      filters: {
        name: "",
        serverDomain: "",
        issuerUrl: "",
        activ: "",
      },
      fields: [
        { key: "name",         label: "Name",                 sortable: true  },
        { key: "serverDomain", label: "Server-Domain",        sortable: true  },
        { key: "issuerUrl",    label: "Issuer URL",           sortable: false },
        { key: "activ",        label: this.$t('global.status'), sortable: true, searchable: false },
      ],
    };
  },
  computed: {
   filteredTenants() {
     console.log("FILTER WIRD AUSGEFÜHRT");
  console.log("FILTER NAME:", this.filters.name);
  console.log("TENANTS ANZAHL:", this.tenants.length);
  const names = (this.filters.name || "")
    .split(",")
    .map(name => name.trim().toLowerCase())
    .filter(Boolean);

  return this.tenants.filter((t) => {
    const tenantName = (t.name || "").toLowerCase();

    const nameOk =
      names.length === 0 ||
      names.some(searchName => tenantName.includes(searchName));

    const domainOk =
      !this.filters.serverDomain ||
      (t.serverDomain || "")
        .toLowerCase()
        .includes(this.filters.serverDomain.toLowerCase());

    const issuerOk =
      !this.filters.issuerUrl ||
      (t.issuerUrl || "")
        .toLowerCase()
        .includes(this.filters.issuerUrl.toLowerCase());

    return nameOk && domainOk && issuerOk;
  });
},
  },
  async mounted() {
    await this.loadTenants();
  },
  methods: {
    async loadTenants() {
      this.loading = true;
      try {
        const res = await Api.get("stammdaten/sso-tenant");
        this.tenants = res.data;
      } catch (e) {
        this.$notify({ type: "error", title: this.$t("global.error"), text: e.message });
      } finally {
        this.loading = false;
      }
    },
    openTenant(tenant) {
      this.$router.push({ name: "sso-tenant", params: { id: tenant.id } });
    },
  },
};
</script>
